import React from 'react';
import classnames from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import License from '../../../License';
import FoldableTagList from '../../../FoldableTagList';
import TextRenderer from '../../../TextRenderer/TextRenderer';
import Tags from '../../../Tags';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import MatureIndicator from '../../../SubmissionDetails/_partials/MatureIndicator';
import s from './Literature.scss';
export var LiteratureDetails = function (_a) {
    var _b;
    var deviation = _a.deviation, _c = _a.deviation, isMature = _c.isMature, deviationId = _c.deviationId, author = _c.author, publishedTime = _c.publishedTime, _d = _c.extended, _e = _d === void 0 ? {} : _d, license = _e.license, descriptionText = _e.descriptionText, tags = _e.tags, className = _a.className, contentClassName = _a.contentClassName;
    var devpage_tags_update = useFlag('devpage_tags_update');
    var isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    var _f = useSubscriptionTier(deviation), isSubscribedButBlocked = _f.isSubscribedButBlocked, needsSubscription = _f.needsSubscription;
    var isBlocked = needsSubscription || isSubscribedButBlocked;
    var isDescriptionTextShown = !!((_b = descriptionText === null || descriptionText === void 0 ? void 0 : descriptionText.html) === null || _b === void 0 ? void 0 : _b.markup) &&
        !isBlocked;
    return (React.createElement("div", { className: classnames(s['root'], className, contentClassName) }, isExtendedLoaded && (React.createElement(React.Fragment, null,
        tags && (React.createElement("div", { className: s['tags'] }, devpage_tags_update ? (React.createElement(FoldableTagList, { tags: tags })) : (React.createElement(Tags, { key: "detailsTags-".concat(deviationId), tags: tags })))),
        isDescriptionTextShown && (React.createElement(TextRenderer
        // TODO: search and remove all instances of 'as unknown as PapiEditorText'
        // when PapiExtendedDeviation.descriptionText is PapiEditorText and not string in papi types
        , { 
            // TODO: search and remove all instances of 'as unknown as PapiEditorText'
            // when PapiExtendedDeviation.descriptionText is PapiEditorText and not string in papi types
            textContent: descriptionText, className: s['description'], legacyTheme: "literature-description" })),
        React.createElement("div", { className: s['misc'] },
            isMature && React.createElement(MatureIndicator, null),
            React.createElement("div", { className: s['license'] },
                React.createElement(License, { license: license, author: author, publishedTime: publishedTime })))))));
};
LiteratureDetails.displayName = 'LiteratureDetails';
export default LiteratureDetails;
//# sourceMappingURL=Literature.js.map